import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-timer-flash-line text-xl text-primary-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              实时快讯
            </h2>
          </div>
          <p className="text-sm text-foreground-500">24小时滚动更新，追踪每一条最新爆料</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200 hidden sm:block"></div>
          <div className="space-y-0">
            {updatesData.map((item, idx) => (
              <div key={item.id} className="relative flex gap-4 pb-5 last:pb-0">
                <div className="hidden sm:flex flex-col items-center pt-1.5 flex-shrink-0">
                  <div className={`w-2.5 h-2.5 rounded-full border-2 border-background-50 ${
                    item.tagColor === 'accent' ? 'bg-accent-500' : 'bg-primary-500'
                  }`}></div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className={`inline-flex px-2 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                      item.tagColor === 'accent'
                        ? 'bg-accent-100 text-accent-800'
                        : 'bg-primary-100 text-primary-800'
                    }`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium leading-relaxed hover:text-primary-600 transition-colors cursor-pointer">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}